<div class="modal-header">
  <h6 class="modal-title" i18n="@@components.icon_picker.modal_title">Choose an icon</h6>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">&times;</button>
</div>

<div class="modal-body icon-picker-modal">
  <input
    type="text"
    class="form-control form-control-sm mb-3"
    [ngModel]="search()"
    (ngModelChange)="search.set($event)"
    i18n-placeholder="@@components.icon_picker.search_placeholder"
    placeholder="Search icons…"
    autocomplete="off"
    autofocus />

  <div class="icon-picker-modal__grid">
    @for (name of results(); track name) {
      <button
        type="button"
        class="icon-picker-modal__item"
        [class.active]="name === model"
        (click)="select(name)"
        [attr.aria-label]="name"
        [title]="name">
        <fa-icon [icon]="['fas', name]" [fixedWidth]="true"></fa-icon>
      </button>
    } @empty {
      <p class="icon-picker-modal__empty" i18n="@@components.icon_picker.empty">No icons match your search.</p>
    }
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="button-secondary" (click)="clear()"><span i18n="@@components.icon_picker.clear">No icon</span></button>
  <button type="button" class="button-secondary-outlined" (click)="close()"><span i18n="@@common.close">Close</span></button>
</div>
